// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__FVvyr","buttons":"SendReceipts_buttons__2_nhj","email":"SendReceipts_email__3Vbc9","bookApptTitle":"SendReceipts_bookApptTitle__2gnHy"};